
// // src/lib/servicesApi.js
// // Uses Firebase modular SDK (v9+). Point imports to your existing firebase config.

// import { db } from "../firebase"; // <-- use your existing firebase export
// import {
//   collection,
//   doc,
//   addDoc,
//   setDoc,
//   updateDoc,
//   deleteDoc,
//   serverTimestamp,
//   onSnapshot,
//   query,
//   where,
//   orderBy,
// } from "firebase/firestore";

// // Path: admin / services / homeservice
// export const homeserviceCol = collection(db, "admin", "services", "homeservice");

// // Live subscription (all active services). Optional filter by category.
// export const subscribeHomeServices = (onData, onError, { category } = {}) => {
//   const q = category && category !== "all"
//     ? query(homeserviceCol, where("category", "==", category), orderBy("title"))
//     : query(homeserviceCol, orderBy("title"));

//   return onSnapshot(
//     q,
//     (snap) => {
//       const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
//       onData(items);
//     },
//     (err) => {
//       console.error("HomeServices snapshot error:", err);
//       onError?.(err);
//     }
//   );
// };

// // Create a new service
// export const createHomeService = async ({
//   category,
//   type,     // slug e.g., "maid-basic"
//   title,
//   desc,
//   icon,     // bootstrap icon class
//   price,    // number or string to convert
//   active = true,
// }) => {
//   const payload = {
//     category,
//     type,
//     title,
//     desc,
//     icon,
//     price: typeof price === "number" ? price : parseFloat(price),
//     active: !!active,
//     createdAt: serverTimestamp(),
//     updatedAt: serverTimestamp(),
//   };
//   return await addDoc(homeserviceCol, payload);
// };

// // Update an existing service
// export const updateHomeService = async (id, updates) => {
//   const ref = doc(homeserviceCol, id);
//   const payload = {
//     ...updates,
//     ...(updates.price != null ? { price: parseFloat(updates.price) } : {}),
//     updatedAt: serverTimestamp(),
//   };
//   await updateDoc(ref, payload);
// };

// // Soft toggle active
// export const setHomeServiceActive = async (id, active) => {
//   const ref = doc(homeserviceCol, id);
//   await updateDoc(ref, { active: !!active, updatedAt: serverTimestamp() });
// };

// // Delete
// export const deleteHomeService = async (id) => {
//   const ref = doc(homeserviceCol, id);
//   await deleteDoc(ref);
// };


// src/lib/servicesApi.js
import { db } from "../firebase"; // your configured Firestore instance
import {
  collection,
  doc,
  addDoc,
  setDoc,
  updateDoc,
  deleteDoc,
  serverTimestamp,
  onSnapshot,
  query,
  where,
} from "firebase/firestore";

/* Paths */
export const categoriesCol   = collection(db, "admin", "services", "categories");
export const homeserviceCol  = collection(db, "admin", "services", "homeservice");

/* ---------- Categories ---------- */

// Subscribe to all categories
export const subscribeCategories = (onData, onError) => {
  // Simple subscription; sort client-side
  return onSnapshot(
    categoriesCol,
    (snap) => {
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      // sort by label
      items.sort((a,b) => (a.label || "").localeCompare(b.label || ""));
      onData(items);
    },
    (err) => onError?.(err)
  );
};

// Create category
export const createCategory = async ({ key, label, active = true }) => {
  if (!key) throw new Error("Category key is required");
  const payload = {
    key,
    label: label || key,
    active: !!active,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  return await addDoc(categoriesCol, payload);
};

// Update category
export const updateCategory = async (id, updates) => {
  const ref = doc(categoriesCol, id);
  const payload = {
    ...updates,
    updatedAt: serverTimestamp(),
  };
  await updateDoc(ref, payload);
};

// Toggle active
export const setCategoryActive = async (id, active) => {
  const ref = doc(categoriesCol, id);
  await updateDoc(ref, { active: !!active, updatedAt: serverTimestamp() });
};

// Delete category (NOTE: you may want to prevent deleting if services exist)
export const deleteCategory = async (id) => {
  const ref = doc(categoriesCol, id);
  await deleteDoc(ref);
};

/* ---------- Home & Kitchen services ---------- */

// Subscribe to services (optional server-side filter by category)
export const subscribeHomeServices = (onData, onError, { category } = {}) => {
  const q =
    category && category !== "all"
      ? query(homeserviceCol, where("category", "==", category))
      : homeserviceCol;

  return onSnapshot(
    q,
    (snap) => {
      const items = snap.docs.map((d) => ({ id: d.id, ...d.data() }));
      // Client-side sort by title (avoid composite index)
      items.sort((a,b) => (a.title || "").localeCompare(b.title || ""));
      onData(items);
    },
    (err) => onError?.(err)
  );
};

// Create service
export const createHomeService = async ({
  category, // key string
  type,     // slug
  title,
  desc,
  icon,
  price,
  active = true,
}) => {
  const payload = {
    category,
    type,
    title,
    desc,
    icon,
    price: typeof price === "number" ? price : parseFloat(price),
    active: !!active,
    createdAt: serverTimestamp(),
    updatedAt: serverTimestamp(),
  };
  return await addDoc(homeserviceCol, payload);
};

// Update service
export const updateHomeService = async (id, updates) => {
  const ref = doc(homeserviceCol, id);
  const payload = {
    ...updates,
    ...(updates.price != null ? { price: parseFloat(updates.price) } : {}),
    updatedAt: serverTimestamp(),
  };
  await updateDoc(ref, payload);
};

// Toggle active
export const setHomeServiceActive = async (id, active) => {
  const ref = doc(homeserviceCol, id);
  await updateDoc(ref, { active: !!active, updatedAt: serverTimestamp() });
};

// Delete
export const deleteHomeService = async (id) => {
  const ref = doc(homeserviceCol, id);
  await deleteDoc(ref);
};
